import React from "react"
import { conversationMessagesShape } from "utils/propTypeShapes"
import ConversationMessageListItem from "./ConversationMessageListItem"

const ConversationMessageList = ({ messages }) => (
  <div>
    {
      messages.map((message) => {
        const { id } = message

        return (
          <ConversationMessageListItem key={id} message={message} />
        )
      })
    }
  </div>
)

ConversationMessageList.propTypes = {
  messages: conversationMessagesShape.isRequired,
}

export default ConversationMessageList
